import { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import "../../assets/css/style.css";
import UserIcon from "../../assets/angket/user.png";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-regular-svg-icons";
import { APILA } from "../../config/apila";

const getResponseData = (response) => {
  return response?.data?.data ?? response?.data ?? {};
};

const token = localStorage.getItem("token");

const RATING_OPTIONS = [
  { value: 1, label: "Jarang" },
  { value: 2, label: "Kadang" },
  { value: 3, label: "Sering" },
  { value: 4, label: "Selalu" },
];

export default function PageForm() {
  const navigate = useNavigate();
  const location = useLocation();
  document.title = "Form Penilaian";

  const studentProfile = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("student_profile") || "{}");
    } catch {
      return {};
    }
  }, []);

  // const student = useMemo(() => {
  //   return {
  //     name: studentProfile?.nama_siswa || "-",
  //     studentId: localStorage.getItem("nisn") || "-",
  //     ysb_student_id: studentProfile?.ysb_student_id || "",
  //     ysb_branch_id: studentProfile?.ysb_branch_id || "",
  //     ysb_school_id: studentProfile?.ysb_school_id || "",
  //     ysb_grade_level_id: studentProfile?.ysb_grade_level_id || "",
  //     ysb_kelas_id: studentProfile?.ysb_kelas_id || "",
  //     ysb_semester_id: studentProfile?.ysb_semester_id || "",
  //     // optional (jika ada)
  //     user_id:
  //       studentProfile?.user_id ||
  //       studentProfile?.ysb_user_id ||
  //       localStorage.getItem("user_id") ||
  //       "",
  //   };
  // }, [studentProfile]);

  // const params = new URLSearchParams(location.search);
  // const type = params.get("type") === "peer" ? "peer" : "self";

  const params = new URLSearchParams(location.search);
const type = params.get("type") === "peer" ? "peer" : "self";

const student = useMemo(() => {
  const semesterFromDashboard =
    params.get("ysb_semester_id") ||
    localStorage.getItem("ysb_semester_id") ||
    studentProfile?.ysb_semester_id ||
    "";

  return {
    name: studentProfile?.nama_siswa || "-",
    studentId: localStorage.getItem("nisn") || "-",
    ysb_student_id: studentProfile?.ysb_student_id || "",
    ysb_branch_id: studentProfile?.ysb_branch_id || "",
    ysb_school_id: studentProfile?.ysb_school_id || "",
    ysb_grade_level_id: studentProfile?.ysb_grade_level_id || "",
    ysb_kelas_id: studentProfile?.ysb_kelas_id || "",

    // ✅ semester mengikuti dashboard / semester aktif status = 1
    ysb_semester_id: semesterFromDashboard,

    // optional (jika ada)
    user_id:
      studentProfile?.user_id ||
      studentProfile?.ysb_user_id ||
      localStorage.getItem("user_id") ||
      "",
  };
}, [studentProfile, location.search]);

  // ✅ hanya dipakai untuk peer (siswa yang dinilai)
// support key baru: siswa_dinilai_id
const ysb_student_id2 =
  params.get("siswa_dinilai_id") ||
  params.get("ysb_student_id2") ||
  params.get("student2") ||
  location?.state?.siswa_dinilai_id ||
  location?.state?.ysb_student_id2 ||
  localStorage.getItem("siswa_dinilai_id") ||
  localStorage.getItem("ysb_student_id2") ||
  "";

  // ====== STATE API ======
  const [loadingFetch, setLoadingFetch] = useState(true);
  const [fetchError, setFetchError] = useState("");
  const [apiStudentInfo, setApiStudentInfo] = useState(null);
  const [apiProgress, setApiProgress] = useState(null);

  // ✅ data API (section/subtitle/items)
  const [sections, setSections] = useState([]);

  // ====== META untuk autosave (per sub element) ======
  // key: ysb_sub_element_id -> meta: { recordId, ysb_element_id, ysb_sub_element_id }
  const [subMetaMap, setSubMetaMap] = useState({});

  // ====== STATE FORM ======
  const [step, setStep] = useState(0);
  const [loadingAction, setLoadingAction] = useState(null); // submit | next | prev
  const [answers, setAnswers] = useState({}); // key: ysb_sub_element_id => 1..4

  // loading per item saat autosave
  const [savingMap, setSavingMap] = useState({}); // { [ysb_sub_element_id]: true }

  // get nama rekan yang dinilai
   const [setNamaRekan, namaRekan] = useState([]);


  const [modalNotif, setModalNotif] = useState({
    open: false,
    type: "sukses", // sukses | info | peringatan
    title: "",
    message: "",
    confirmText: "Oke, Mengerti",
    onConfirm: null,
  });

  // ====== HIGHLIGHT JAWABAN KOSONG ======
  // aktif saat user klik tombol di modal "Jawaban Belum Lengkap"
  const [highlightMissing, setHighlightMissing] = useState(false);
  const [missingIds, setMissingIds] = useState({}); // { [ysb_sub_element_id]: true }

  // modal konfirmasi kirim
  const [confirmSubmit, setConfirmSubmit] = useState({
    open: false,
    title: "Konfirmasi Kirim Penilaian",
    message:
      "Apakah Anda sudah yakin dengan penilaian yang diberikan?\nJika Ya, maka Anda tidak akan bisa mengubah nilai tersebut.",
  });

  const bukaModal = ({
    type = "info",
    title = "",
    message = "",
    confirmText = "Oke, Mengerti",
    onConfirm = null,
  }) => {
    setModalNotif({
      open: true,
      type,
      title,
      message,
      confirmText,
      onConfirm,
    });
  };

  const tutupModal = () => {
    setModalNotif({
      open: false,
      type: "info",
      title: "",
      message: "",
      confirmText: "Oke, Mengerti",
      onConfirm: null,
    });
  };

  // ====== HEADER AXIOS ======
  const axiosHeaders = useMemo(() => {
    return {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
  }, []);

  // ====== FETCH QUESTIONS (DINAMIS SELF/PEER) ======
  useEffect(() => {
    const fetchQuestions = async () => {
      setLoadingFetch(true);
      setFetchError("");

      // const url =
      //   type === "self"
      //     ? "https://api.la.sims.alazharsummarecon.sch.id/api/angket-self/questions"
      //     : "https://api.la.sims.alazharsummarecon.sch.id/api/angket-peer/questions";

      const url =
        type === "self"
          ? "/api/angket-self/questions"
          : "/api/angket-peer/questions";

      // const payload = {
      //   // key lama (ysb_student_id / ysb_student_id2) sudah diganti oleh backend untuk endpoint peer
      //   // ✅ SELF tetap pakai ysb_student_id (sesuai endpoint self)
      //   ...(type === "self"
      //     ? { ysb_student_id: student.ysb_student_id }
      //     : {
      //         // ✅ PEER: key baru dari backend
      //         siswa_penilai_id: student.ysb_student_id,
      //         siswa_dinilai_id: ysb_student_id2,
      //       }),
      //   ysb_semester_id: student.ysb_semester_id,
      //   ysb_grade_level_id: student.ysb_grade_level_id,
      //   ysb_school_id: student.ysb_school_id,
      // };

      const payload = {
        ...(type === "self"
          ? { ysb_student_id: student.ysb_student_id }
          : {
              siswa_penilai_id: student.ysb_student_id,
              siswa_dinilai_id: ysb_student_id2,
            }),
        ysb_semester_id: student.ysb_semester_id,
        ysb_grade_level_id: student.ysb_grade_level_id,
        ysb_school_id: student.ysb_school_id,
      };

      console.log('hah', payload)


      try {
        const res = await APILA.get(url, { params: payload, headers: axiosHeaders });
        const data = getResponseData(res);

        setApiStudentInfo(data?.student_info || null);
        setApiProgress(data?.progress || null);
        // setNamaRekan(data?.student_info.nama_siswa_dinilai || null);

        // ===== build sections + meta map =====
        const nextSections = [];
        const nextMetaMap = {};
        const prefill = {};

        (data?.questions || []).forEach((dimensi) => {
          const dimensiName = dimensi?.name_dimensi || "-";

          (dimensi?.elements || []).forEach((el) => {
            const subtitle = el?.description || "-";
            const ysb_element_id = el?.ysb_element_id || el?.id || "";

            const items = (el?.sub_elements || []).map((se) => {
              const ysb_sub_element_id = se?.ysb_sub_element_id || "";
              const recordId = se?.id; // <-- ini yang dipakai untuk /default vs /{id}
              const title = se?.ysb_sub_element_name || "-";

              if (ysb_sub_element_id) {
                nextMetaMap[ysb_sub_element_id] = {
                  recordId,
                  ysb_element_id,
                  ysb_sub_element_id,
                };
              }

              const val = se?.ysb_sub_element_value;
              if (
                ysb_sub_element_id &&
                val !== null &&
                val !== undefined &&
                val !== ""
              ) {
                const n = Number(val);
                if ([1, 2, 3, 4].includes(n)) prefill[ysb_sub_element_id] = n;
              }

              return {
                id: ysb_sub_element_id, // ✅ kunci jawaban selalu ysb_sub_element_id
                title,
              };
            });

            nextSections.push({
              section: dimensiName,
              subtitle,
              items,
            });
          });
        });

        setSubMetaMap(nextMetaMap);
        setSections(nextSections);
        setAnswers(prefill);
        setStep(0);
      } catch (err) {
        setFetchError(
          err?.response?.data?.message ||
            err?.message ||
            "Gagal mengambil data angket."
        );
      } finally {
        setLoadingFetch(false);
      }
    };

    // validasi minimal data
    if (
      !student.ysb_student_id ||
      !student.ysb_semester_id ||
      !student.ysb_grade_level_id ||
      !student.ysb_school_id
    ) {
      setLoadingFetch(false);
      setFetchError(
        "Data profil siswa belum lengkap. Pastikan student_profile sudah tersimpan."
      );
      return;
    }
    if (type === "peer" && !ysb_student_id2) {
  setLoadingFetch(false);
  setFetchError(
    "ID siswa yang dinilai (siswa_dinilai_id) belum tersedia untuk angket peer."
  );
  return;
}

    fetchQuestions();
  }, [
    type,
    ysb_student_id2,
    student.ysb_student_id,
    student.ysb_semester_id,
    student.ysb_grade_level_id,
    student.ysb_school_id,
    axiosHeaders,
  ]);

  // ====== DERIVED ======
  const currentSection = sections[step];
  const progressPercent = sections.length ? ((step + 1) / sections.length) * 100 : 0;

  const totalQuestions = useMemo(
    () => (sections || []).reduce((acc, sec) => acc + (sec?.items?.length || 0), 0),
    [sections]
  );

  const answeredCount = Object.keys(answers).length;
  const isLastStep = step === sections.length - 1;
  const isFirstStep = step === 0;

  const sectionAnswered = currentSection?.items
    ? currentSection.items.filter((q) => answers[q.id]).length
    : 0;

  const getMissingQuestionIds = (secs, ans) => {
    const miss = [];
    (secs || []).forEach((sec) => {
      (sec?.items || []).forEach((it) => {
        if (it?.id && !ans?.[it.id]) miss.push(it.id);
      });
    });
    return miss;
  };

  const findStepByQuestionId = (qid) => {
    for (let i = 0; i < (sections || []).length; i++) {
      const sec = sections[i];
      if ((sec?.items || []).some((it) => it?.id === qid)) return i;
    }
    return 0;
  };

  const focusMissingAnswers = () => {
    const miss = getMissingQuestionIds(sections, answers);
    if (!miss.length) return;

    const map = {};
    miss.forEach((id) => {
      map[id] = true;
    });

    setMissingIds(map);
    setHighlightMissing(true);

    // pindah ke step yang pertama kali belum terisi
    const firstMissingId = miss[0];
    const targetStep = findStepByQuestionId(firstMissingId);
    setStep(targetStep);

    // scroll halus ke atas card form agar highlight terlihat
    try {
      window?.scrollTo({ top: 0, behavior: "smooth" });
    } catch {
      window?.scrollTo(0, 0);
    }
  };

  // ====== AUTOSAVE PUT (default vs by id) ======
  const buildAutoSavePayload = (ysb_sub_element_id, ysb_sub_element_value) => {
    const meta = subMetaMap?.[ysb_sub_element_id] || {};
    const ysb_element_id = meta?.ysb_element_id || "";

    // utamakan dari student_info API (biasanya paling lengkap)
    const si = apiStudentInfo || {};

    const payload = {
      ysb_branch_id: si?.ysb_branch_id || student.ysb_branch_id,
      ysb_school_id: si?.ysb_school_id || student.ysb_school_id,
      ysb_semester_id: si?.ysb_semester_id || student.ysb_semester_id,
      ysb_grade_level_id: si?.ysb_grade_level_id || student.ysb_grade_level_id,
      ysb_kelas_id: si?.ysb_kelas_id || student.ysb_kelas_id,

      ysb_teacher_id: si?.ysb_teacher_id || studentProfile?.ysb_teacher_id || "",
      ysb_teacher_id2:
        si?.ysb_teacher_id2 || studentProfile?.ysb_teacher_id2 || "",

      // untuk self/peer: ambil dari student_info bila ada
      ysb_student_id:
  si?.ysb_student_id || si?.siswa_penilai_id || student.ysb_student_id,
// beberapa kasus peer butuh student_id2 (siswa yang dinilai)
ysb_student_id2:
  si?.ysb_student_id2 ||
  si?.siswa_dinilai_id ||
  (type === "peer" ? ysb_student_id2 : ""),

      // ✅ tambahan key untuk backend peer (aman karena hanya extra fields)
      ...(type === "peer"
        ? {
            siswa_penilai_id:
              si?.siswa_penilai_id || si?.ysb_student_id || student.ysb_student_id,
            siswa_dinilai_id:
              si?.siswa_dinilai_id ||
              si?.ysb_student_id2 ||
              (type === "peer" ? ysb_student_id2 : ""),
          }
        : {}),

      ysb_element_id,
      ysb_sub_element_id,
      ysb_sub_element_value,
    };

    // optional: beberapa server minta user_id (dari screenshot kamu)
    // const user_id =
    //   student.user_id ||
    //   si?.user_id ||
    //   si?.ysb_user_id ||
    //   localStorage.getItem("user_id") ||
    //   "";
    // if (user_id) payload.user_id = user_id;
    
    // ✅ server minta user_id -> pakai ysb_student_id (student_id)
        payload.user_id =
      si?.ysb_student_id || si?.siswa_penilai_id || student.ysb_student_id || "";
     

    return payload;
  };

  const savingAbortRef = useRef({}); // optional anti race

  const putAutoSave = async (ysb_sub_element_id, value) => {
    const meta = subMetaMap?.[ysb_sub_element_id];
    if (!meta) {
      throw new Error("Meta sub element tidak ditemukan.");
    }

    const recordId = meta?.recordId;
    const isDefault = !recordId || String(recordId).toLowerCase() === "default";

    // const base =
    //   type === "self"
    //     ? "https://api.la.sims.alazharsummarecon.sch.id/api/angket-self"
    //     : "https://api.la.sims.alazharsummarecon.sch.id/api/angket-peer";
    const base =
      type === "self"
        ? "/api/angket-self"
        : "/api/angket-peer";
    const url = isDefault ? `${base}/default` : `${base}/${recordId}`;

    const payload = buildAutoSavePayload(ysb_sub_element_id, value);

    // tandai request key (anti race sederhana)
    const reqKey = `${ysb_sub_element_id}-${Date.now()}`;
    savingAbortRef.current[ysb_sub_element_id] = reqKey;

    const res = await APILA.put(url, payload, { headers: axiosHeaders });

    // kalau ada request lebih baru, abaikan hasil lama
    if (savingAbortRef.current[ysb_sub_element_id] !== reqKey) return { ignored: true };

    const data = getResponseData(res);

    // jika berhasil dan tadinya default, update recordId dari response (biasanya ada "id")
    const returnedId = data?.data?.id || data?.id || res?.data?.data?.id;
    if (isDefault && returnedId) {
      setSubMetaMap((prev) => ({
        ...prev,
        [ysb_sub_element_id]: {
          ...(prev?.[ysb_sub_element_id] || {}),
          recordId: returnedId,
        },
      }));
    }

    return data;
  };

  const onChooseRating = async (ysb_sub_element_id, value) => {
    // optimistic UI
    const prevValue = answers[ysb_sub_element_id];
    setAnswers((prev) => ({ ...prev, [ysb_sub_element_id]: value }));

    // kalau sebelumnya ditandai merah, hilangkan saat user memilih
    if (highlightMissing) {
      setMissingIds((prev) => {
        if (!prev?.[ysb_sub_element_id]) return prev;
        const next = { ...prev };
        delete next[ysb_sub_element_id];
        return next;
      });
    }

    // set loading per item
    setSavingMap((prev) => ({ ...prev, [ysb_sub_element_id]: true }));

    try {
      await putAutoSave(ysb_sub_element_id, value);
      // sukses: tidak perlu modal (biar tidak ganggu). Kalau mau notif kecil, bisa ditambah.
    } catch (err) {
      // rollback
      setAnswers((prev) => {
        const next = { ...prev };
        if (prevValue === undefined) delete next[ysb_sub_element_id];
        else next[ysb_sub_element_id] = prevValue;
        return next;
      });

      bukaModal({
        type: "peringatan",
        title: "Gagal Menyimpan Nilai",
        message:
          err?.response?.data?.message ||
          err?.message ||
          "Terjadi kesalahan saat menyimpan nilai. Silakan coba lagi.",
      });
    } finally {
      setSavingMap((prev) => ({ ...prev, [ysb_sub_element_id]: false }));
    }
  };

  // ====== SUBMIT (tetap alur lama + confirm modal) ======
  const doSubmitAfterConfirm = async () => {
    setLoadingAction("submit");
    try {
      if (answeredCount < totalQuestions) {
        bukaModal({
          type: "peringatan",
          title: "Jawaban Belum Lengkap",
          message: `Masih ada jawaban kosong (${answeredCount}/${totalQuestions}). Silakan lengkapi terlebih dahulu.`,
          confirmText: "Tunjukkan yang belum diisi",
          onConfirm: () => {
            focusMissingAnswers();
          },
        });
        return;
      }

      // NOTE: endpoint submit final belum diberikan.
      // Saat ini hanya mempertahankan behaviour lama (modal sukses + redirect).
      await new Promise((res) => setTimeout(res, 900));

      bukaModal({
        type: "sukses",
        title: "Penilaian Berhasil Dikirim",
        message:
          type === "self"
            ? "Penilaian diri berhasil dikirim."
            : "Penilaian rekan berhasil dikirim.",
        onConfirm: () => navigate("/dashboard-siswa"),
      });
    } finally {
      setLoadingAction(null);
    }
  };

  const onClickKirimPenilaian = () => {
    setConfirmSubmit((p) => ({ ...p, open: true }));
  };


  return (
    <div style={styles.page}>
      {/* Topbar */}
      <header style={styles.topbar}>
        <div style={styles.brandWrap}>
          <div style={styles.brandIcon}>🎓</div>
          <span style={styles.brandText}>SIMAM</span>
        </div>

        <div style={styles.topbarRight}>
          <div style={styles.userBox}>
            <div>
              <img src={UserIcon} alt="user" />
            </div>

            <div>
              <div style={styles.userName}>{student.name}</div>
              <div style={styles.userRole}>Siswa</div>
            </div>
          </div>
          <button type="button" style={styles.logoutBtn} onClick={() => navigate("/")}>
            ⤴ Keluar
          </button>
        </div>
      </header>

      <main style={styles.container}>
        {/* Header */}
        <section style={{ marginBottom: 16 }}>
          <h1 style={styles.pageTitle}>
            {type === "self" ? "Penilaian Diri" : "Penilaian Rekan"}
          </h1>

          {/* Panduan */}
          <section style={styles.guideCard}>
            <h4 style={styles.guideTitle}>Panduan Penilaian</h4>
            <ul style={styles.guideList}>
              <li>Isi penilaian sesuai kondisi dan kebiasaan yang sebenarnya.</li>
              <li>Gunakan skala 1–4 secara konsisten pada setiap pernyataan.</li>
              <li>Pastikan semua pernyataan sudah terisi sebelum kirim.</li>
              <li>Data penilaian digunakan untuk pembinaan karakter siswa.</li>
            </ul>
            <div style={{ marginTop: 10 }}>
              <div style={{ marginTop: 6, fontSize: 12, opacity: 0.85 }}>
                Catatan: <b>1</b> adalah nilai terendah dan <b>4</b> adalah nilai
                tertinggi.
              </div>
            </div>
          </section>
        </section>

        {/* Loading / Error / Empty */}
        {loadingFetch ? (
          <section style={styles.formCard}>
            <div style={{ fontWeight: 800, fontSize: 16 }}>Memuat pertanyaan...</div>
            <div style={{ color: "#6B7280", marginTop: 6 }}>
              Mohon tunggu, data sedang diambil dari server.
            </div>
          </section>
        ) : fetchError ? (
          <section style={styles.formCard}>
            <div style={{ fontWeight: 800, fontSize: 16, color: "#B91C1C" }}>
              Gagal Memuat Data
            </div>
            <div style={{ color: "#6B7280", marginTop: 6 }}>{fetchError}</div>
            <div style={{ marginTop: 14 }}>
              <Button
                color="primary"
                style={styles.btnPrimary}
                onClick={() => window.location.reload()}
              >
                Coba Lagi
              </Button>
            </div>
          </section>
        ) : !sections?.length ? (
          <section style={styles.formCard}>
            <div style={{ fontWeight: 800, fontSize: 16 }}>Data tidak tersedia</div>
            <div style={{ color: "#6B7280", marginTop: 6 }}>
              Pertanyaan angket belum tersedia untuk siswa ini.
            </div>
          </section>
        ) : (
          <>
            {type === "self" 
            ?
            ""
            
            : <section style={styles.progressCard}>
              <h5 style={{fontSize:"17px", fontStyle: "italic", lineHeight: "25px"}} > Kamu Sedang Menilai : <span style={{color: "#4F46E5", fontStyle: "normal"}}> {apiStudentInfo.nama_siswa_dinilai}</span></h5>
            </section> 
            }
            {/* Progress */}
            <section style={styles.progressCard}>
              <div style={styles.progressHead}>
                <span style={styles.progressLabel}>Progres</span>
                <span style={styles.progressStep}>
                  Langkah {step + 1} dari {sections.length}
                </span>
              </div>
              <div style={styles.progressTrack}>
                <div style={{ ...styles.progressFill, width: `${progressPercent}%` }} />
              </div>
            </section>

            {/* Form Card */}
            <section className="body" style={styles.formCard}>
              <h2 style={styles.sectionTitle}>{currentSection?.section}</h2>
              <p style={styles.sectionSub}>{currentSection?.subtitle}</p>

              {currentSection?.items?.map((item) => (
                <div
                  key={item.id}
                  style={{
                    ...styles.questionWrap,
                    ...(highlightMissing && missingIds?.[item.id] && !answers?.[item.id]
                      ? styles.questionWrapMissing
                      : {}),
                  }}
                >
                  <h3
                    className="question-title"
                    style={
                      highlightMissing && missingIds?.[item.id] && !answers?.[item.id]
                        ? styles.questionTitleMissing
                        : undefined
                    }
                  >
                    {item.title}
                  </h3>

                  <div style={styles.ratingGrid}>
                    {RATING_OPTIONS.map((opt) => {
                      const active = answers[item.id] === opt.value;
                      const saving = !!savingMap[item.id];
                      const missing =
                        highlightMissing && missingIds?.[item.id] && !answers?.[item.id];

                      return (
                        <button
                          key={opt.value}
                          type="button"
                          onClick={() => onChooseRating(item.id, opt.value)}
                          disabled={saving || loadingAction !== null}
                          title={saving ? "Menyimpan..." : "Klik untuk memilih"}
                          style={{
                            ...styles.rateBtn,
                            ...(active ? styles.rateBtnActive : {}),
                            ...(saving ? styles.rateBtnSaving : {}),
                            ...(missing ? styles.rateBtnMissing : {}),
                          }}
                        >
                          <div className="rate-num" style={{marginTop: "12px"}} >
                            {opt.value}
                          </div>
                          {/* {saving && <div style={styles.savingText}>Menyimpan</div>} */}

                           {/* {saving && active ? (
                              <div style={styles.savingText}>Menyimpan</div>
                            ) : (
                             
                              <></>
                            )} */}

                            {saving && active ? (
                              <div style={styles.savingText}>Menyimpan</div>
                            ) : (
                              <div style={styles.rateLabel} >{opt.label}</div>
                            )}


                        </button>
                      );
                    })}
                  </div>
                </div>
              ))}

              {/* footer buttons */}
              <div style={styles.formFooter}>
                {!isFirstStep && (
                  <Button
                    color="light"
                    disabled={loadingAction !== null}
                    onClick={() => setStep((s) => Math.max(0, s - 1))}
                    style={styles.btnPrev}
                  >
                    ‹ Sebelumnya
                  </Button>
                )}
                {isLastStep ? (
                  <Button
                    color="primary"
                    onClick={onClickKirimPenilaian}
                    disabled={loadingAction !== null}
                    style={styles.btnPrimary}
                  >
                    {loadingAction === "submit" ? (
                      "Mengirim..."
                    ) : (
                      <>
                        <FontAwesomeIcon icon={faPaperPlane} style={{ marginRight: 8 }} />
                        Kirim Penilaian
                      </>
                    )}
                  </Button>
                ) : (
                  
                  <Button
                    color="primary"
                    onClick={() => setStep((s) => Math.min(sections.length - 1, s + 1))}
                    disabled={loadingAction !== null}
                    style={styles.btnPrimary}
                  >
                    Berikutnya ›
                  </Button>
                )}
              </div>

              <p style={styles.counterInfo}>
                Selesai di bagian ini: {sectionAnswered}/{currentSection?.items?.length || 0} •
                Total terjawab: {answeredCount}/{totalQuestions}
              </p>
            </section>
          </>
        )}
      </main>

      {/* ===== Modal Konfirmasi Kirim ===== */}
      {confirmSubmit.open && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalCard}>
            <div style={{ ...styles.modalIcon, ...styles.modalIconWarning }}>!</div>

            <h3 style={styles.modalTitle}>{confirmSubmit.title}</h3>
            <p style={styles.modalMessage} className="pre-line">
              {confirmSubmit.message}
            </p>

            <div style={styles.modalActionsRow}>
              <button
                type="button"
                style={styles.modalBtnGhost}
                onClick={() => setConfirmSubmit((p) => ({ ...p, open: false }))}
                disabled={loadingAction !== null}
              >
                Batal
              </button>
              <button
                type="button"
                style={styles.modalBtnPrimary}
                onClick={() => {
                  setConfirmSubmit((p) => ({ ...p, open: false }));
                  doSubmitAfterConfirm();
                }}
                disabled={loadingAction !== null}
              >
                Ya, Kirim
              </button>
            </div>

            <div style={styles.modalHint}>
              Setelah dikirim, nilai tidak dapat diubah.
            </div>
          </div>
        </div>
      )}

      {/* ===== Modal Notif (tetap sama) ===== */}
      {modalNotif.open && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalCard}>
            <div
              style={{
                ...styles.modalIcon,
                ...(modalNotif.type === "sukses"
                  ? styles.modalIconSuccess
                  : modalNotif.type === "peringatan"
                  ? styles.modalIconWarning
                  : styles.modalIconInfo),
              }}
            >
              {modalNotif.type === "sukses"
                ? "✓"
                : modalNotif.type === "peringatan"
                ? "!"
                : "i"}
            </div>

            <h3 style={styles.modalTitle}>{modalNotif.title}</h3>
            <p style={styles.modalMessage}>{modalNotif.message}</p>

            <div style={styles.modalActions}>
              <button
                type="button"
                style={styles.modalBtnPrimary}
                onClick={() => {
                  const cb = modalNotif.onConfirm;
                  tutupModal();
                  if (cb) cb();
                }}
              >
                {modalNotif.confirmText || "Oke, Mengerti"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background: "#F3F4F6",
    fontFamily:
      'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    color: "#111827",
  },
  topbar: {
    height: 74,
    background: "#FFFFFF",
    borderBottom: "1px solid #E5E7EB",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 22px",
    position: "sticky",
    top: 0,
    zIndex: 20,
  },
  brandWrap: { display: "flex", alignItems: "center", gap: 10 },
  brandIcon: {
    width: 32,
    height: 32,
    borderRadius: 8,
    background: "#EEF2FF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  brandText: { fontSize: 20, fontWeight: 700, color: "#1F2937" },
  topbarRight: { display: "flex", alignItems: "center", gap: 12 },
  userBox: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "6px 10px",
    border: "1px solid #E5E7EB",
    borderRadius: 12,
    background: "#FFFFFF",
  },
  userName: { fontSize: 13, fontWeight: 700, lineHeight: 1.2 },
  userRole: { fontSize: 12, color: "#6B7280" },
  logoutBtn: {
    border: "none",
    background: "transparent",
    color: "#EF4444",
    fontWeight: 700,
    cursor: "pointer",
  },

  container: { maxWidth: 980, margin: "0 auto", padding: "26px 16px 30px" },

  pageTitle: { margin: 0, fontSize: 30, fontWeight: 800 },

  progressCard: {
    background: "#fff",
    border: "1px solid #E5E7EB",
    borderRadius: 12,
    padding: 16,
    marginBottom: 16,
  },
  progressHead: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 10,
  },
  progressLabel: { fontSize: 16, fontWeight: 700 },
  progressStep: { fontSize: 14, color: "#6B7280", fontWeight: 600 },
  progressTrack: {
    height: 8,
    width: "100%",
    borderRadius: 999,
    background: "#E5E7EB",
    overflow: "hidden",
  },
  progressFill: {
    height: "100%",
    borderRadius: 999,
    background: "#4F46E5",
    transition: "width .25s ease",
  },

  formCard: {
    background: "#fff",
    border: "1px solid #E5E7EB",
    borderRadius: 12,
    padding: 22,
    marginBottom: 16,
  },
  sectionTitle: { margin: 0, fontSize: 21, fontWeight: 700, color: "#403abc" },
  sectionSub: { marginTop: 4, color: "#6B7280", fontSize: 15 },

  questionWrap: { padding: "16px 0", borderBottom: "1px solid #E5E7EB" },
  questionWrapMissing: {
    // background: "#FEF2F2",
    // border: "1px solid #FCA5A5",
    borderRadius: 10,
    // padding: 16,
    // marginTop: 10,
  },

  questionTitleMissing: {
    color: "#B91C1C",
  },

  ratingGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, minmax(20px, 1fr))",
    gap: 10,
    marginTop: 12,
  },
  rateLabel : {
    marginTop: 15,
fontWeight: 800,
  },
  rateBtn: {
    border: "1px solid #D1D5DB",
    background: "#fff",
    borderRadius: 8,
    padding: "8px 6px",
    cursor: "pointer",
    minHeight: 56,
    position: "relative",
  },
  rateNum: {
    fontSize: 20,
    fontWeight: 800,
    lineHeight: 1,
    marginBottom: 0,
  },
  rateBtnActive: {
    border: "2px solid #4F46E5",
    boxShadow: "0 0 0 2px rgba(79,70,229,0.12)",
    background: "#EEF2FF",
  },
  rateBtnSaving: {
    opacity: 0.75,
    cursor: "not-allowed",
  },
  rateBtnMissing: {
    border: "2px solid #EF4444",
    boxShadow: "0 0 0 2px rgba(239,68,68,0.12)",
  },
  savingText: {
    marginTop: 6,
    fontSize: 11,
    fontWeight: 700,
    color: "#6B7280",
  },

  formFooter: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 10,
    marginTop: 16,
  },
  btnPrev: { minWidth: 120, borderRadius: 10, fontWeight: 700 },
  btnPrimary: {
    minWidth: 180,
    borderRadius: 10,
    backgroundColor: "#4F46E5",
    borderColor: "#4F46E5",
    fontWeight: 700,
  },
  counterInfo: { marginTop: 10, fontSize: 13, color: "#6B7280", fontWeight: 600 },

  guideCard: {
    background: "#F9FAFB",
    border: "1px solid #E5E7EB",
    borderRadius: 12,
    padding: 18,
    marginTop: 20,
  },
  guideTitle: {
    margin: 0,
    fontSize: 16,
    fontWeight: 600,
    color: "#4F46E5",
  },
  guideList: {
    margin: "10px 0 0",
    paddingLeft: 18,
    color: "#6B7280",
    lineHeight: 1.85,
    fontSize: 15,
  },

  modalOverlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(17,24,39,0.45)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
    padding: 16,
  },
  modalCard: {
    width: "100%",
    maxWidth: 440,
    background: "#FFFFFF",
    borderRadius: 16,
    border: "1px solid #E5E7EB",
    boxShadow: "0 20px 45px rgba(0,0,0,0.22)",
    padding: "22px 20px 18px",
    textAlign: "center",
    animation: "fadeInModal .2s ease",
  },
  modalIcon: {
    width: 56,
    height: 56,
    borderRadius: "50%",
    margin: "0 auto 12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 28,
    fontWeight: 800,
  },
  modalIconSuccess: {
    background: "#DCFCE7",
    color: "#166534",
  },
  modalIconWarning: {
    background: "#FEF3C7",
    color: "#92400E",
  },
  modalIconInfo: {
    background: "#DBEAFE",
    color: "#1D4ED8",
  },
  modalTitle: {
    margin: "0 0 6px",
    fontSize: 22,
    fontWeight: 800,
    color: "#111827",
  },
  modalMessage: {
    margin: 0,
    fontSize: 14,
    lineHeight: 1.6,
    color: "#4B5563",
    whiteSpace: "pre-line",
  },
  modalActions: {
    marginTop: 16,
    display: "flex",
    justifyContent: "center",
  },
  modalActionsRow: {
    marginTop: 16,
    display: "flex",
    justifyContent: "center",
    gap: 10,
  },
  modalBtnPrimary: {
    border: "none",
    background: "#4F46E5",
    color: "#fff",
    fontWeight: 700,
    borderRadius: 10,
    padding: "10px 16px",
    minWidth: 140,
    cursor: "pointer",
  },
  modalBtnGhost: {
    border: "1px solid #E5E7EB",
    background: "#FFFFFF",
    color: "#111827",
    fontWeight: 800,
    borderRadius: 10,
    padding: "10px 16px",
    minWidth: 120,
    cursor: "pointer",
  },
  modalHint: {
    marginTop: 12,
    fontSize: 12,
    color: "#6B7280",
    fontWeight: 600,
  },
};